import React, { createContext, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { db } from "../../config/firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

export const MyContext = createContext("");

function Home() {
  const [totalSize, setTotalSize] = useState(0);
  const [totalSizePercent, setTotalSizePercent] = useState(0);
  const [fileImgCount, setFileImgCount] = useState(0);
  const [fileVideoCount, setFileVideoCount] = useState(0);
  const { user } = useUserAuth();
  const calculateTotalFileSize = async () => {
    if (!user?.email) {
      setTotalSize(0);
      setTotalSizePercent(0);
      setFileImgCount(0);
      setFileVideoCount(0);
      return;
    }

    try {
      const q = query(collection(db, "files"), where("userEmail", "==", user.email));
      const querySnapshot = await getDocs(q);
      const items = querySnapshot.docs.map(doc => doc.data());

      let totalSizeSum = 0;
      let imgCount = 0;
      let videoCount = 0;

      for (const file of items) {
        totalSizeSum += file.size || 0;
        // Check if the content type is an image
        if (file.contentType && file.contentType.startsWith("image/")) {
          imgCount += 1;
        }
        // Check if the content type is a video
        if (file.contentType && file.contentType.startsWith("video/")) {
          videoCount += 1;
        }
      }
      setFileImgCount(imgCount);
      setFileVideoCount(videoCount);
      setTotalSize(totalSizeSum);
      const maxTotalSize = 100 * 1024 * 1024; // 100MB
      const totalSizePercentValue = (totalSizeSum / maxTotalSize) * 100;
      setTotalSizePercent(totalSizePercentValue);
    } catch (error) {
      console.error("Error calculating total file size:", error);
      setTotalSize(0);
      setTotalSizePercent(0);
    }
  };

  useEffect(() => {
    if (user && user.email) {
      calculateTotalFileSize();
    }
  }, [user]);

  return (
    <MyContext.Provider
      value={{
        calculateTotalFileSize,
        totalSize,
        totalSizePercent,
        setTotalSize,
        setTotalSizePercent,
        fileVideoCount,
        fileImgCount,
      }}
    >
      <div className="w-full h-screen flex">
        <Sidebar />
        <div className="w-full h-screen bg-slate-100">
          <Navbar />
          <Outlet />
        </div>
      </div>
    </MyContext.Provider>
  );
}

export default Home;
